import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  role: { code: '', allowallowedRoutes: [] },
  accessToken: null,
  name: '',
  config: {},
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    updateUserRole: (state, action) => ({
      ...state,
      role: {
        ...state.role,
        ...action.payload.role,
      },
      accessToken: action.payload.accessToken || state.accessToken,
      refreshToken: action.payload.refreshToken || state.refreshToken,
      refreshTokenId: action.payload.refreshTokenId || state.refreshTokenId,
      name: action.payload.name || state.name,
    }),
    updateUser: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    resetUser: () => initialState,
  },
});

export const { updateUserRole, updateUser, resetUser } = userSlice.actions;
export default userSlice.reducer;
